/**
 * <yg-cart-upsell> — sepet çekmecesindeki "Tamamlayan Parçalar" bölümü.
 *
 * Kaynak, ürün sayfasındaki "Kombinle" bölümüyle AYNI: Shopify'ın
 * complementary (tamamlayıcı) öneri motoru. İkisi de aynı metafielde bakıyor
 * (shopify--discovery--product_recommendation.complementary_products), yani
 * sepette çıkan öneri, ürün sayfasında görülenle tutarlı.
 *
 * Liquid'den tamamlayıcı ürün sorgulanamıyor, bu yüzden kartlar
 * sections/yg-cart-upsell.liquid bölümünden Section Rendering API ile
 * çekiliyor.
 *
 * Eleman varsayılan olarak hidden: hiç öneri toplanamazsa bölüm görünmez,
 * boş bir başlık kalmaz.
 *
 * NEDEN SEPETTEKİ TÜM ÜRÜNLER SIRAYLA DENENİYOR: 250 aktif ürünün 3'ünde
 * tamamlayıcı eşleştirmesi yok. Yalnızca ilk satıra bakıldığında, sepetteki
 * diğer ürünlerin eşleştirmesi dolu olsa bile bölüm boş kalıyordu. Sıra sepet
 * sırası — ki Shopify yeni satırı BAŞA koyuyor, yani ilk satır en son eklenen
 * ürün: müşterinin en taze niyeti. Hedef karta ulaşılınca sonraki sepet
 * ürünleri için istek atılmıyor.
 *
 * ---- MORPH: BU DOSYANIN EN ÖNEMLİ KISMI ----
 *
 * Sepet değiştiğinde çekmece YENİDEN KURULMUYOR, YERİNDE GÜNCELLENİYOR.
 * snippets/cart-drawer.liquid'deki data-hydration-key="cart-drawer-inner"
 * yüzünden assets/morph.js çekmecenin içini sunucudan gelen taze HTML'e
 * dönüştürüyor. Sonuçları ölçüldü (adet artır/azalt):
 *   - Eleman örneği AYNI kalıyor, DOM'dan hiç kopmuyor
 *   - Dolayısıyla connectedCallback bir daha ÇALIŞMIYOR
 *   - Sunucudan gelen kabuk boş olduğu için enjekte edilen kartlar SİLİNİYOR
 *   - hidden niteliği GERİ GELİYOR
 * Yani bölüm ilk sepet etkileşiminde kayboluyordu.
 *
 * Çözüm bir MutationObserver: bölüm sıfırlanmış hâle döndüğünde kendini
 * yeniden basıyor. Olay dinlemek yerine bunun seçilmesinin sebebi,
 * StandardEvents.cartLinesUpdate'in morph'tan ÖNCE tetiklenmesi — o sırada
 * basılan kartları hemen ardından gelen morph yine silerdi.
 *
 * Sonsuz döngü yok: gözlemci yalnızca "gizli ya da liste boş" durumunda iş
 * yapıyor, bastıktan sonra durum bu olmaktan çıkıyor.
 *
 * Gereksiz ağ trafiği yok: kartlar bellekte tutuluyor. Sepetteki ürün listesi
 * değişmediyse (örneğin sadece adet arttıysa) yeniden basmak için istek
 * atılmıyor. Liste değiştiyse eleme kümesi de değişmiş demektir, o zaman
 * yeniden çekiliyor.
 *
 * Betik bu dosyadan değil snippets/cart-drawer.liquid'in tepesinden
 * yükleniyor — gerekçesi orada yazılı (innerHTML ile eklenen script
 * etiketleri çalışmaz).
 */

/**
 * Kaç kart toplanınca sepet ürünlerini denemeyi bırakırız.
 *
 * Bölüm yatay kaydırılabilir ve en az dört ürün göstermeli. Tamamlayıcı
 * eşleştirmeleri ürün başına dörder tanımlı, yani sepetin ilk ürünü tek
 * başına hedefi tutturuyor ve ikinci istek hiç atılmıyor. Sepette zaten
 * olanlar elenince dörtten aza düşerse sıradaki sepet ürününe geçiliyor.
 */
const HEDEF_KART = 4;

/**
 * Toplanan kart sayısının üst sınırı. Hedefe ulaşılan istekte gelen fazla
 * kartlar atılmıyor — kaydırıcı zaten taşıyor — ama liste sonsuza kadar
 * uzamasın diye tavan var.
 */
const AZAMI_KART = 8;

/**
 * Kaç sepet ürününün tamamlayıcısı sorulur. Sınır olmadan 20 satırlık bir
 * sepet 20 istek atardı; ilk birkaç ürün pratikte zaten yetiyor.
 */
const KAYNAK_SINIRI = 3;

if (!customElements.get('yg-cart-upsell')) {
  customElements.define(
    'yg-cart-upsell',
    class YgCartUpsell extends HTMLElement {
      /** @type {AbortController | null} */
      #controller = null;

      /** @type {MutationObserver | null} */
      #gozlemci = null;

      /**
       * Kartları üreten sepet ürün listesi. Bellekteki kartların hangi sepet
       * için geçerli olduğunu söyler; liste değişince yeniden çekilir.
       * @type {string | null}
       */
      #imza = null;

      /**
       * Bellekteki kartlar. Hiç DOM'a girmemiş kopyalar tutuluyor, her
       * basışta klonlanıyor: morph aynı düğümleri defalarca söküp takabilir
       * ve iç bileşenler (product-card, quick-add) her seferinde temiz
       * başlasın isteniyor.
       * @type {Element[]}
       */
      #kartlar = [];

      #istekUcuyor = false;

      connectedCallback() {
        this.#controller = new AbortController();

        this.#gozlemci = new MutationObserver(() => this.#sifirlandiysaBas());
        this.#gozlemci.observe(this, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['hidden', 'data-cart-products'],
        });

        this.#uygula();
      }

      disconnectedCallback() {
        this.#controller?.abort();
        this.#gozlemci?.disconnect();
        this.#gozlemci = null;
      }

      /** Morph bölümü sıfırladıysa yeniden bas. Başka durumda hiçbir şey yapma. */
      #sifirlandiysaBas() {
        const liste = this.querySelector('[data-yg-upsell-list]');
        if (!liste) return;
        if (!this.hidden && liste.children.length > 0) return;
        this.#uygula();
      }

      /** Bellekte varsa bas, yoksa çek. */
      #uygula() {
        const imza = this.dataset.cartProducts || '';
        if (!imza) return;

        if (imza !== this.#imza) {
          this.#imza = imza;
          this.#kartlar = [];
          this.#getir(imza);
          return;
        }

        // İmza aynı ve kart yoksa: bu sepet için zaten bakıldı, öneri çıkmadı.
        if (this.#kartlar.length > 0) this.#bas();
      }

      #bas() {
        const liste = this.querySelector('[data-yg-upsell-list]');
        if (!liste) return;

        liste.replaceChildren(...this.#kartlar.map((kart) => kart.cloneNode(true)));
        this.hidden = false;

        // Kendi değişikliklerimiz gözlemciye geri dönmesin.
        this.#gozlemci?.takeRecords();
      }

      /**
       * Sepetteki ürünlerin tamamlayıcılarını sırayla çeker.
       * @param {string} imza - İsteği başlatan sepet ürün listesi.
       */
      async #getir(imza) {
        if (this.#istekUcuyor) return;
        this.#istekUcuyor = true;

        const sepetUrunleri = imza.split(',').filter(Boolean);
        // Aynı liste iki işi görüyor: hem öneri kaynağı hem eleme kümesi.
        const sepette = new Set(sepetUrunleri);
        const kok = this.dataset.url || '/recommendations/products';
        const toplanan = new Map();

        try {
          for (const urunId of sepetUrunleri.slice(0, KAYNAK_SINIRI)) {
            // limit=10: complementary zaten metafielddeki kadarini donuyor
            // (urun basina dort), ama ileride daha fazla eslestirme
            // tanimlanirsa istek tarafi sinir olmasin.
            const adres =
              `${kok}?product_id=${encodeURIComponent(urunId)}` +
              `&intent=complementary&limit=10&section_id=yg-cart-upsell`;

            try {
              const yanit = await fetch(adres, { signal: this.#controller?.signal });
              if (!yanit.ok) continue;

              const belge = new DOMParser().parseFromString(await yanit.text(), 'text/html');

              for (const kart of belge.querySelectorAll('[data-yg-upsell-card]')) {
                const id = kart.dataset.productId;
                // toplanan kontrolü şart: iki sepet ürünü aynı ceketi önerebilir.
                if (!id || sepette.has(id) || toplanan.has(id)) continue;
                toplanan.set(id, kart);
                if (toplanan.size >= AZAMI_KART) break;
              }
            } catch (hata) {
              if (hata.name === 'AbortError') return;
              console.warn('[yg-cart-upsell]', hata);
            }

            // Hedefe ulaşıldıysa sıradaki sepet ürününe istek atma. Bu yüzden
            // tavan (AZAMI_KART) değil hedef (HEDEF_KART) kontrol ediliyor:
            // gelen yanıttaki fazla kartlar zaten yukarıda alındı.
            if (toplanan.size >= HEDEF_KART) break;
          }
        } finally {
          this.#istekUcuyor = false;
        }

        // İstek uçarken sepet değiştiyse bu sonuç bayat: baştan al.
        if ((this.dataset.cartProducts || '') !== imza) {
          this.#imza = null;
          this.#uygula();
          return;
        }

        this.#kartlar = [...toplanan.values()];
        if (this.#kartlar.length > 0) this.#bas();
      }
    }
  );
}
